<div class="page-title animatedBackground">
    <div class="container">
        <h3>Course</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Manage Courses</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="contact-area ptb-50">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <h3>Add Course</h3>
            </div>

            <div class="mt-4 col-lg-12 col-md-12">
                <form id="contactForm" [formGroup]="courseForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="courseTitle" class="form-control"
                                    placeholder="Course Title">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseTitle')?.invalid && courseForm.get('courseTitle')?.touched">
                                    Course Title is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="courseSubTitle" class="form-control"
                                    placeholder="Course Subtitle">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseSubTitle')?.invalid && courseForm.get('courseSubTitle')?.touched">
                                    Course Subtitle is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="courseCategory" class="form-control"
                                    placeholder="Course Category">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseCategory')?.invalid && courseForm.get('courseCategory')?.touched">
                                    Course Category is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="courseTags" class="form-control"
                                    placeholder="Course Tags">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseTags')?.invalid && courseForm.get('courseTags')?.touched">
                                    Course Tags is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="number" formControlName="courseAmount" class="form-control"
                                    placeholder="Course Amount">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseAmount')?.invalid && courseForm.get('courseAmount')?.touched">
                                    Course Amount is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="courseAuthors" class="form-control"
                                    placeholder="Course Authors">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseAuthors')?.invalid && courseForm.get('courseAuthors')?.touched">
                                    Course Aothors is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="time" formControlName="courseFinishTime" class="form-control"
                                    placeholder="Course Finish Time">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseFinishTime')?.invalid && courseForm.get('courseFinishTime')?.touched">
                                    Course Finish Time is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <label for="formFile" class="form-label">Upload Course Image</label>
                            <div class="form-group">
                                <input class="form-control" formControlName="courseImagePath" type="file" id="formFile">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseImagePath')?.invalid && courseForm.get('courseImagePath')?.touched">
                                    Course Image is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <label for="formFile" class="form-label">Upload Course Sample File</label>
                            <div class="form-group">
                                <input class="form-control" formControlName="courseSampleFilePath" type="file"
                                    id="formFile">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseSampleFilePath')?.invalid && courseForm.get('courseSampleFilePath')?.touched">
                                    Course Sample File is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <label for="formFile" class="form-label">Upload Course Document</label>
                            <div class="form-group">
                                <input class="form-control" formControlName="courseFilePath" type="file" id="formFile">
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseFilePath')?.invalid && courseForm.get('courseFilePath')?.touched">
                                    Course File is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <textarea name="message" class="form-control" formControlName="courseDescription"
                                    id="message" cols="30" rows="5" placeholder="Course Description"></textarea>
                                <div class="form-error-message"
                                    *ngIf="courseForm.get('courseDescription')?.invalid && courseForm.get('courseDescription')?.touched">
                                    Course Description is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <button type="submit" class="btn btn-primary me-md-3"
                                (click)="clickOnSubmit()">Submit</button>
                            <button type="submit" class="pl-2 btn btn-danger" (click)="clearCourse()">Clear</button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="mt-5 col-lg-12 col-md-12">
                <table class="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Title</th>
                            <th scope="col">Subtitle</th>
                            <th scope="col">Category</th>
                            <th scope="col">Tags</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Author</th>
                            <th scope="col">Finish Time</th>
                            <th scope="col">Description</th>
                            <th scope="col">Image</th>
                            <th scope="col">Sample</th>
                            <th scope="col">Original</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let course of courseList; let i=index">
                            <th scope="row">{{i+1}}</th>
                            <td>{{course.courseTitle}}</td>
                            <td>{{course.courseSubTitle}}</td>
                            <td>{{course.courseCategory}}</td>
                            <td>{{course.courseTags}}</td>
                            <td>{{course.courseAmount}}</td>
                            <td>{{course.courseAuthors}}</td>
                            <td>{{course.courseFinishTime}}</td>
                            <td>{{course.courseDescription}}</td>
                            <td class="w-80"><button type="button" class="btn btn-link">View</button></td>
                            <td class="w-80"><button type="button" class="btn btn-link">View</button></td>
                            <td class="w-80"><button type="button" class="btn btn-link">View</button></td>
                            <td class="w-145">
                                <button type="button" class="btn btn-primary btn-sm me-md-2"
                                    (click)="getCourseById(course?._id)">Edit</button>
                                <button type="button" class="btn btn-danger btn-sm"
                                    (click)="deleteAdminCourse(course?._id)">Delete</button>
                            </td>
                        </tr>
                        <tr *ngIf="courseList.length == 0" class="text-center">
                            <td colspan="8">No Data Found.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>